import type { RngStream } from '../core/rng';

export interface DamageNumber {
  x: number;
  y: number;
  vy: number;
  life: number;
  maxLife: number;
  text: string;
  crit: boolean;
  heal: boolean;
}

const MAX_NUMBERS = 48;

/** 浮动伤害数字：暴击更大更久；纯表现层。 */
export class DamageNumbers {
  list: DamageNumber[] = [];

  spawn(
    x: number, y: number, amount: number,
    crit: boolean, rng: RngStream,
  ): void {
    let d = this.list.find((n) => n.life <= 0);
    if (!d) {
      if (this.list.length >= MAX_NUMBERS) return;
      d = {
        x: 0, y: 0, vy: 0, life: 0, maxLife: 1, text: '',
        crit: false, heal: false,
      };
      this.list.push(d);
    }
    d.x = x + rng.range(-8, 8);
    d.y = y - 6;
    d.vy = -72;
    d.maxLife = crit ? 0.8 : 0.55;
    d.life = d.maxLife;
    d.text = String(Math.round(amount));
    d.crit = crit;
    d.heal = false;
  }

  /** 回血数字：绿色、带 + 号。 */
  spawnHeal(x: number, y: number, amount: number): void {
    let d = this.list.find((n) => n.life <= 0);
    if (!d) {
      if (this.list.length >= MAX_NUMBERS) return;
      d = {
        x: 0, y: 0, vy: 0, life: 0, maxLife: 1, text: '',
        crit: false, heal: true,
      };
      this.list.push(d);
    }
    d.x = x; d.y = y - 8;
    d.vy = -60;
    d.maxLife = 0.7;
    d.life = d.maxLife;
    d.text = `+${Math.round(amount)}`;
    d.crit = false;
    d.heal = true;
  }

  update(dt: number): void {
    for (const d of this.list) {
      if (d.life <= 0) continue;
      d.life -= dt;
      d.y += d.vy * dt;
      d.vy *= 0.9;
    }
  }
}
